import { useEventCallback } from '@mui/material';
import ActDomainForm from 'civil-status/components/domain-management/form';
import { ActNewDomainManagement } from 'civil-status/constants/breadcrumb';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformRequestActDomain } from '../utils/transform-act-domain-request';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';
import { ActDomainFormVM } from 'civil-status/view-models/act-domain-form';
import { __ACT_API_URL__ } from 'shell/constants/environment';

const NewDomainManagementPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/stato-civile/ricerca-dominio');
  };

  const saveActDomain = useHttpClient(`${__ACT_API_URL__}/tipo-dominio-atti/insert`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const onSubmit = useEventCallback((values: ActDomainFormVM) => {
    const data = transformRequestActDomain(values);

    (
      saveActDomain({
        data,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/stato-civile/ricerca-dominio');
    });
  });

  return (
    <>
      <Breadcrumbs items={ActNewDomainManagement} />
      <ActDomainForm
        title="Inserimento dominio"
        isForCreate
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </>
  );
};
NewDomainManagementPage.displayName = 'New Domain Management Page';
const ActNewDomainManagementPage = memo(NewDomainManagementPage);
export default ActNewDomainManagementPage;
